import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Layout } from './Layout';
import { ScrollToTop } from './ScrollToTop';
import { Home } from './pages/Home';
import { Nice06 } from './pages/Nice06';
import { VarToulon } from './pages/VarToulon';
import { Tarifs } from './pages/Tarifs';
import { Devis } from './pages/Devis';
import { Faq } from './pages/Faq';
import { BlogList } from './pages/BlogList';
import { BlogPost } from './pages/BlogPost';
import './index.css';

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/nice-06" element={<Nice06 />} />
          <Route path="/var-toulon" element={<VarToulon />} />
          <Route path="/tarifs" element={<Tarifs />} />
          <Route path="/devis" element={<Devis />} />
          <Route path="/faq" element={<Faq />} />
          <Route path="/blog" element={<BlogList />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default App;
